import React, { useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from '@components/common';

const MODAL_OPEN_CLASS = 'body--modal-open';

const DialogBox = props => {
  const { show, onClickOutside, ...restProps } = props;
  useEffect(() => {
    if (show) {
      document.body.classList.add(MODAL_OPEN_CLASS);
    } else {
      document.body.classList.remove(MODAL_OPEN_CLASS);
    }

    return () => {
      document.body.classList.remove(MODAL_OPEN_CLASS);
    };
  }, [show]);

  return (
    <Wrapper>
      <Modal show={show} onClick={onClickOutside} {...restProps}>
        <div
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {props.children}
        </div>
      </Modal>
    </Wrapper>
  );
};

DialogBox.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  onClickOutside: PropTypes.func
};
export default DialogBox;

const Wrapper = styled(Box)`
  position: relative;
  z-index: 100;
`;

const Modal = styled(Box)`
  display: flex;
  visibility: ${props => (props.show ? 'visible' : 'hidden')};
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  transition: opacity 0.4s ease-out, background-color 0.4s ease-out;
  position: fixed;
  z-index: 99999;

  opacity: ${props => (props.show ? 1 : 0)};
  overflow-y: scroll;
`;

Modal.defaultProps = {
  bg: 'grayTint',
  justifyContent: 'center',
  alignItems: 'center'
};
